import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import { Message } from "element-react";
import {
  Button,
  Dropdown,
  Menu,
  Space,
  message,
  Modal,
  Form,
  Select,
  Col,
  Row,
  Input,
} from "antd";
import { getCurrentUser, removeAll, debounce } from "utils/storage";
import Header from "./header"; //是否登录
import HeaderSearch from "./headerSearch"; //搜索
import NavMenu from "../NavMenu"; //菜单导航
import Bread from "../Breadcrumb";
import { getToken } from "../../utils/storage";
import md5 from "js-md5";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
let userToken = getCurrentUser();

const { Option } = Select;
const FormItem = Form.Item;
let phoneReg =
  /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
require("./index.scss");

export default class GlobalHeader extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      nav: this.props.nav,
      history: this.props.history,
      userName: "空",
      visible: false,
      phone: "",
      loading: false,
      count: 60,
      liked: true,
      cmsLoading: false,
      selectFlag: 0,
    };
  }
  componentDidMount() {
    const { pathname } = this.props.history.location;
    console.log("pathnamepathnamepathname", pathname);
    if (pathname == "/entrance/home") {
      this.setState({ selectFlag: 1 });
    } else if (pathname == "/entrance/employment") {
      this.setState({ selectFlag: 2 });
    } else if (pathname == "/entrance/education") {
      this.setState({ selectFlag: 3 });
    } else if (pathname == "/entrance/entrepreneurship") {
      this.setState({ selectFlag: 4 });
    } else if (pathname == "/entrance/policy") {
      this.setState({ selectFlag: 5 });
    } else if (
      pathname == "/entrance/personal/mechanismInfoManage" ||
      pathname.indexOf("/entrance/personal") != -1
    ) {
      this.setState({ selectFlag: 6 });
    } else if (pathname == "/register") {
      this.setState({ selectFlag: 7 });
    }
    //获取用户消息
    if (getCurrentUser()) {
      // console.log('localStorage.getItem(current-user)',JSON.parse(localStorage.getItem('current-user')));
      // console.log('getCurrentUser()getCurrentUser()getCurrentUser()',);
      // const userInfo = getCurrentUser()
      // console.log('userInfouserInfo',userInfo);
      // this.setState({phone:userInfo.phone})
      // this.setState({userName:userInfo.real_name,userType:userInfo.user_type})

      Http.get(Request.getUserInfo(), {}, (obj) => {
        console.log("userInfo", obj);
        if (obj.code == 200) {
          this.setState({ phone: obj.data.phone });
          this.setState({
            userName: obj.data.realName,
            userType: obj.data.userType,
          });
        } else {
          message.error(obj.msg || obj.message || "请求失败，请重试");
        }
      });
    } else {
      // 未登录
    }
    Http.get(Request.getDictionaries(), { code: "poli_affi_code" }, (obj) => {
      if (obj.code == 200) {
        // message.success('发送成功')
      } else {
        message.error(obj.msg ? obj.msg : "发送失败");
      }
    });
  }

  // 跳转到个人中心
  handlePersonal() {
    const { userName, userType } = this.state;
    if (userType) {
      let userType = getCurrentUser().user_type;
      const { history } = this.props;
      if (userType == 2) {
        // history.push("/entrance/personal/userInfo")
        window.location.href = "/entrance/personal/userInfo";
      } else if (userType == 5) {
        // history.push("/entrance/personal/mechanismInfoManage")
        window.location.href = "/entrance/personal/mechanismInfoManage";
      } else if (userType == 6) {
        // history.push("/entrance/personal/mechanismInfoManage")
        window.location.href = "/entrance/personal/mechanismInfoManage";
      } else if (userType == 7) {
        // history.push("/entrance/personal/mechanismInfoManage")
        window.location.href = "/entrance/personal/mechanismInfoManage";
      }
    } else {
      message.error("请先登录");
    }
  }

  //修改密码弹窗
  handleOk = () => {
    this.setState({ visible: false });
  };
  //关闭弹窗
  handleCancel = () => {
    this.setState({ visible: false });
  };
  handleClick() {
    const token = getToken();
    if (token) {
      this.props.history.push({ pathname: "/entrance/comminicate" });
    } else {
      Message({
        message: "您还没有登录哦！",
        type: "warning",
      });
    }
  }
  //退出登录
  loginOut = () => {
    let that = this;
    Modal.confirm({
      title: "退出确认",
      content: "确定要退出登录吗？",
      okText: "确定",
      okType: "primary",
      cancelText: "取消",
      onOk() {
        removeAll();
        that.setState({ userName: "", userType: "" });
        // console.log(this.props);
        // window.location.reload()
        that.props.history.push({ pathname: "/entrance/home" });
      },
      onCancel() {},
    });
  };
  //倒计时
  countDown() {
    const { count } = this.state;
    if (count === 1) {
      this.setState({
        count: 60,
        liked: true,
      });
    } else {
      this.setState({
        count: count - 1,
        liked: false,
      });
      setTimeout(this.countDown.bind(this), 1000);
    }
  }
  changePwd = () => {
    // message.success('修改密码显示弹窗');

    this.setState({ visible: true });
  };
  //获取验证码
  getHero = () => {
    // getverifyIdentity
    const { phone, liked } = this.state;
    // console.log('phonephone',phone);
    if (!phone) {
      message.error("请输入手机号码");
      return;
    } else if (!phoneReg.test(phone)) {
      message.error("请输入正确的手机号码");
      return;
    } else {
      let params = {
        phone: phone,
        tenantId: 894699,
      };
      this.setState({ cmsLoading: true });
      Http.get(Request.getverifyIdentity(), params, (obj) => {
        // console.log('objobj',obj);
        this.setState({ cmsLoading: false });
        if (obj.code == 200) {
          this.countDown();
          message.success("发送成功");
        } else {
          message.error(obj.msg ? obj.msg : "发送失败");
        }
      });
    }
  };
  submitChange = (e) => {
    if (e.newPassword != e.newPassword1) {
      message.error("两次密码不一致请重新输入");
      return;
    }
    this.setState({ loading: true });
    const { userType } = this.state;
    let params = {
      ...e,
      userType: userType,
    };
    Http.postFrom(Request.changePwd(), params, (obj) => {
      // console.log('objobj',obj);
      if (obj.code == 200) {
        this.setState({ visible: false, loading: false });
        message.success("密码修改成功,即将跳转到登录页面");
        removeAll();
        this.setState({ userName: "" });
        setTimeout(() => {
          this.props.history.push({ pathname: "/login" });
        }, 2000);
      } else {
        this.setState({ loading: false });
        message.error(obj.msg ? obj.msg : "修改失败");
      }
    });
  };
  getApprove = () => {
    const userInfo = getCurrentUser();
    let userTag = userInfo.user_type;
    if (userTag == 2) {
      //退役军人
      this.props.history.push("/entrance/personal/userInfo");
    } else if (userTag == 5) {
      //招聘企业
      this.props.history.push("/entrance/recruitEnterprise/enterpriseInfo");
    } else if (userTag == 6) {
      //培训机构用户
      this.props.history.push("/entrance/personal/mechanismInfoManage");
    } else if (userTag == 7) {
      //金融机构用户
      this.props.history.push("/entrance/personal/mechanismInfoManage");
    }
    // console.log('userInfouserInfouserInfo',userInfo.user_type);
  };
  render() {
    let {
      nav,
      history,
      userName,
      visible,
      loading,
      userType,
      liked,
      count,
      cmsLoading,
      selectFlag,
    } = this.state;

    const menu = (
      <Menu>
        <Menu.Item onClick={() => this.changePwd()}>修改密码</Menu.Item>
        {/* <Menu.Item onClick = {()=>{this.getApprove()}}>去认证</Menu.Item> */}
        <Menu.Item
          onClick={() => {
            this.loginOut();
          }}
        >
          退出
        </Menu.Item>
      </Menu>
    );

    return (
      <div style={{ minWidth: 1200 }}>
        <div className="header-wrapper">
          <div className="header-bg">
            <div className="header-title">眉山市退役军人就业创业网</div>
            {/* <div className="top-slogan"></div> */}
          </div>
          <div className="c_topnav">
            <div
              className={`c_topnavf ${selectFlag == 1 ? "select_btn" : ""} `}
            >
              <a href="/entrance/home">首页</a>
            </div>
            <div
              className={`c_topnavf ${selectFlag == 2 ? "select_btn" : ""} `}
            >
              <a href="/entrance/employment">就业招聘</a>
            </div>
            <div
              className={`c_topnavf ${selectFlag == 3 ? "select_btn" : ""} `}
            >
              <a href="/entrance/education">教育培训</a>
            </div>
            <div
              className={`c_topnavf ${selectFlag == 4 ? "select_btn" : ""} `}
            >
              <a href="/entrance/entrepreneurship">创业帮扶</a>
            </div>
            {/* <div className={`c_topnavf ${selectFlag == 5? 'select_btn':''} `}><a href="/entrance/policy">政策汇总</a></div> */}
            <div
              className={`c_topnavf ${selectFlag == 6 ? "select_btn" : ""} `}
            >
              <a onClick={this.handlePersonal.bind(this)}>个人中心</a>
            </div>
            {/* <div className={`selectFlag ${selectFlag == 1? '':''} `}><a onClick={this.handleClick.bind(this)}>个人中心</a></div> */}
            {userType ? (
              <div className="c_topnavf">
                <Dropdown overlay={menu} placement="bottomLeft" theme="light">
                  <a href="javascript:void(0)">{userName ? userName : "空"}</a>
                </Dropdown>
              </div>
            ) : (
              <div
                className={`c_topnavf ${selectFlag == 7 ? "select_btn" : ""} `}
              >
                {" "}
                <div>
                  <span onClick={() => this.props.history.push("/register")}>
                    注册
                  </span>{" "}
                  /{" "}
                  <span onClick={() => this.props.history.push("/login")}>
                    登录
                  </span>
                </div>
              </div>
            )}
            {/* <div className="c_topnavf c_topnav9"><a href="http://tyjrswt.nmg.gov.cn/djgz/">党建工作</a></div> */}
          </div>
        </div>
        <Modal
          title="修改密码"
          visible={visible}
          onOk={this.handleOk}
          // confirmLoading={confirmLoading}
          onCancel={this.handleCancel}
          width={400}
          footer={null}
        >
          <Form onFinish={this.submitChange}>
            <Row gutter={24}>
              {/* <Col span={24}>
              <FormItem
                  name="userType"
                  rules={[{ required: true, message: '请选择账号类型' }]}
              >
                  <Select
                      className='EndSelect'
                      placeholder="请选择账号类型"
                  >
                      <Option value='2'>退役军人</Option>
                      <Option value='5'>招聘企业用户</Option>
                      <Option value='6'>培训机构用户</Option>
                      <Option value='7'>金融机构用户</Option>
                  </Select>
                  
              </FormItem>
            </Col> */}
              <Col span={24}>
                <FormItem
                  name="phone"
                  initialValue={this.state.phone}
                  rules={[
                    {
                      required: true,
                      validator: (rule, value, callback) => {
                        if (value && !phoneReg.test(value)) {
                          callback("请输入正确的手机号码");
                        } else {
                          callback();
                        }
                      },
                    },
                  ]}
                >
                  <Input
                    // prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    type="number"
                    placeholder="请输入手机号码"
                    disabled={true}
                    onChange={(value) =>
                      this.setState({ phone: value.target.value })
                    }
                  />
                </FormItem>
              </Col>
              <Col span={24}>
                <FormItem
                  name="code"
                  rules={[{ required: true, message: "请输入验证码" }]}
                >
                  <div className="checkCode">
                    <div style={{ width: "66%", float: "left" }}>
                      <Input
                        // prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)', borderRight: 'none' }} />}
                        type="text"
                        placeholder="请输入验证码"
                      />
                    </div>
                    {/* <div style={{ borderRadius: '0 4px 4px 0', float: 'right', fontSize: '22px', fontWeight: 'bold', width: '30%', height: '40px', lineHeight: '40px', border: '1px solid #d9d9d9', color: '#0740d3', textAlign: 'center', boxSizing: 'border-box' }}> */}
                    <Button
                      block
                      type={liked ? "primary" : ""}
                      style={{ float: "right", width: "30%" }}
                      loading={cmsLoading}
                      disabled={!liked}
                      onClick={() => debounce(this.getHero())}
                    >
                      {liked ? "获取验证码" : count}
                    </Button>
                    {/* </div> */}
                  </div>
                </FormItem>
              </Col>
              <Col span={24}>
                <FormItem
                  name="oldPassword"
                  rules={[{ required: true, message: "请输入原密码" }]}
                >
                  <Input
                    // prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    type="password"
                    placeholder="请输入密码"
                  />
                </FormItem>
              </Col>
              <Col span={24}>
                <FormItem
                  name="newPassword"
                  rules={[{ required: true, message: "请输入新密码" }]}
                >
                  <Input
                    // prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    type="password"
                    placeholder="请输入新密码"
                  />
                </FormItem>
              </Col>
              <Col span={24}>
                <FormItem
                  name="newPassword1"
                  rules={[{ required: true, message: "请确认新密码" }]}
                >
                  <Input
                    // prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    type="password"
                    placeholder="请确认新密码"
                  />
                </FormItem>
              </Col>
              <Col span={24}>
                <FormItem>
                  <Button
                    htmlType="submit"
                    style={{
                      width: "100%",
                      height: "40px",
                      color: "#fff",
                      fontSize: "16px",
                      background: "#134AD4",
                      borderColor: "#0740d3",
                      borderRadius: "4px",
                    }}
                    loading={loading}
                  >
                    确认修改
                  </Button>
                </FormItem>
              </Col>
            </Row>
          </Form>
        </Modal>
      </div>
    );
  }
}
